import {
  GET_SETTINGS,
  GET_SETTINGS_ERROR,
  GET_SETTINGS_SUCCESS,
} from '../../../constants/constantsRed';

export const getSettingsRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case GET_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    case GET_SETTINGS_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
